export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.38778f81.woff";